import axios from "axios";

export function changePassword(newPassword) {
  return axios.post("modify-user/change-password", newPassword);
}
